import { FeatureTable } from 'features/assetDatabase/components/assetOverview/assetComponents/FeatureTable'
import { AssetOverviewDataContext } from 'features/assetDatabase/contexts/AssetOverviewDataLayer'
import { AssetOverviewUXContext } from 'features/assetDatabase/contexts/AssetOverviewUXLayer'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import { GeckoFeatureModelType, SortTableByField } from 'types'

import { FeatureAccordionHeader } from './FeatureAccordionHeader'

const TableBox = styled.div`
  padding-bottom: 0.5rem;
`

export const FeatureSectionContent: React.FC<{
  componentID: string
  tableTitle: string
  addName: string
  sortBy: SortTableByField[] | undefined
  tableMessage: string | undefined
  disableEditing: boolean
  featureType: GeckoFeatureModelType
  forceRefresh: () => Promise<void>
}> = ({
  componentID,
  tableTitle,
  addName,
  sortBy,
  tableMessage,
  disableEditing,
  featureType,
}) => {
  const formRef = useRef<HTMLFormElement>(null)

  const [inCollapsedView, setInCollapsedView] = useState(true)
  const {
    inResolveMode,
    inEditMode,
    deletedFeatures,
    handleUndo,
    handleFeatureAdd,
    handleEdit,
    handleSave,
  } = useContext(AssetOverviewUXContext)
  const { assetDataObj } = useContext(AssetOverviewDataContext)
  const handleCollapsedViewChange = () => {
    setInCollapsedView((prev) => !prev)
  }

  const isEditing = inEditMode.includes(`${featureType}_${componentID}`)

  useEffect(() => {
    if (isEditing && inCollapsedView) {
      handleCollapsedViewChange()
    }
  }, [inCollapsedView, isEditing])

  const isMissingDerivedLayerFields = useMemo(() => {
    if (!assetDataObj) return false
    return (
      assetDataObj.components
        .filter(
          (component) => component.componentData.uniqueID === componentID
        )[0]
        .features.filter((feature) => feature.featureJSON.type === featureType)
        .filter(
          (feature) =>
            feature.formFields.filter(
              (field) => field.isNeededForDerivedLayer && !field.value
            ).length > 0
        ).length > 0
    )
  }, [assetDataObj, componentID, featureType])

  return (
    <>
      <FeatureAccordionHeader
        tableTitle={tableTitle}
        addName={addName}
        componentID={componentID}
        featureType={featureType}
        disableEditing={disableEditing}
        handleAddFeature={handleFeatureAdd}
        handleSave={handleSave}
        handleEdit={handleEdit}
        handleCancel={handleUndo}
        handleCollapsedViewChange={handleCollapsedViewChange}
        inCollapsedView={inCollapsedView}
        inEditMode={isEditing}
        inResolveMode={inResolveMode}
        isMissingDerivedLayerFields={isMissingDerivedLayerFields}
        ref={formRef}
      />
      {!inCollapsedView && (
        <TableBox>
          <FeatureTable
            ref={formRef}
            componentID={componentID}
            tableMessage={tableMessage}
            featureType={featureType}
            inEditMode={isEditing}
            inResolveMode={inResolveMode}
            sortBy={sortBy ?? []}
            deletedFeatures={deletedFeatures}
          />
        </TableBox>
      )}
    </>
  )
}
